import React from 'react'

import { Icon, Typography } from 'antd'

import CustomModal from '../../../../../../components/CustomModal/CustomModal'
import { getMessage } from '../../../../../../util/IntlMessages'
import { useManageFieldRelationships } from '../../hooks/useManageFieldRelationships'
import { useManageField } from '../../hooks/useManageFields'

import './styles.less'

export const RemoveRelationshipsModal = ({ message, onOk, onCancel, visible, removeAll = false }) => {
  const { selectedFieldId } = useManageField()

  const { removeAllRelationships } = useManageFieldRelationships({ fieldId: selectedFieldId })

  const handleOk = () => {
    onOk()
    if (removeAll) removeAllRelationships({ targetFieldId: selectedFieldId })
  }

  return (
    <CustomModal
      visible={visible}
      title={<Icon type="warning" className="confirmationModal__icon" />}
      onCancel={onCancel}
      onSubmit={handleOk}
      useBottomButtons={true}
      okText={'confirm'}
      cancelText={'cancel'}
      closable={true}
      centered={true}
      className={'confirmationModal'}
    >
      <div className="confirmationModal__content">
        <Typography.Text>{message}</Typography.Text>
        <Typography.Text>{getMessage('customFieldRemoveRelationships')}</Typography.Text>
      </div>
    </CustomModal>
  )
}
